import { render, staticRenderFns } from "./DetailPanel.vue?vue&type=template&id=3cd1dea3&"
import script from "./DetailPanel.vue?vue&type=script&lang=ts&"
export * from "./DetailPanel.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports